import { defineSlotRecipe } from '@chakra-ui/react'

/**
 * Height of the environment banner, published by the banner while it is mounted. Unset on
 * production, where the banner renders nothing, so the fallback keeps that layout unchanged.
 */
export const ENVIRONMENT_BANNER_HEIGHT_VAR = '--environment-banner-height'

/** Use as `top` for anything sticky or fixed to the top edge, so it sits below the banner. */
export const ENVIRONMENT_BANNER_OFFSET = `var(${ENVIRONMENT_BANNER_HEIGHT_VAR}, 0px)`

export const environmentBannerRecipe = defineSlotRecipe({
  className: 'environment-banner',
  slots: ['root', 'label', 'description'],
  base: {
    // Rendered by EnvironmentBanner in src/components/layout. The colour comes from the
    // environment's colorPalette, so each environment is told apart without reading.
    root: {
      position: 'sticky',
      top: 0,
      // Above the sticky headers ('docked') and page content, below overlays and dialogs.
      zIndex: 'sticky',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'baseline',
      columnGap: 'inline',
      rowGap: 'stack',
      width: 'full',
      paddingInline: '4',
      paddingBlock: '2',
      background: 'colorPalette.solid',
      color: 'colorPalette.contrast',
    },
    label: {
      textStyle: 'smBold',
      whiteSpace: 'nowrap',
    },
    description: {
      textStyle: 'body',
      // Shares the line with the label while there is room, wraps below it on narrow screens.
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: 'xs',
      minWidth: '0',
      overflowWrap: 'anywhere',
    },
  },
})
